<template>
  <div class="ask-ai-ui-modal">
    <div class="modal fancy-scroll">
      <div class="modal-close" @click="close"></div>
      <div class="content">
        <div class="tab">
          <div><i class="fa fa-magic"></i></div>
          <form>
            <div class="custom-wrapper">
              <div>
                <label>AI Fragen :</label>
                <textarea
                  v-if="!isAiDropdownVisible"
                  v-model="uiPrompt"
                  placeholder="starten"
                  :class="{ 'prevent-pointer-event': isShowLoading }"
                ></textarea>
                <div
                  v-if="isShowLoading && !isAiDropdownVisible"
                  class="loading-spinner"
                >
                  <LoadingSpinner />
                </div>
              </div>

              <div
                v-if="!isAiDropdownVisible"
                class="btn btn-senden"
                @click="onAskAiClick"
              >
                Senden
              </div>

              <div v-if="isShowAddCssBtn" class="btn" @click="onAddCssBtnClick">
                <span>Hinzufügen</span>
              </div>

              <div v-if="isShowCssTextArea">
                <label>Antwort :</label>
                <textarea v-model="uiResponse"></textarea>
              </div>
            </div>
          </form>

          <div class="automatedaicss-wrapper" v-if="getAutomatedAICSS">
            <div
              class="automatedaicss-toggle"
              @click="onToggleAICSSElement"
              :class="{ active: isVisibleAutomatedAICSSElement }"
            >
              <span>AI Styles</span>
              <img
                :class="{ up: isVisibleAutomatedAICSSElement }"
                class="automatedaicss-toggle-icon"
                src="../../assets/img/chevron-down.svg"
              />
            </div>
            <b-collapse
              v-model="isVisibleAutomatedAICSSElement"
              class="automatedaicss-toggle-element"
            >
              <b-card>
                <div>
                  <img
                    v-if="getAutomatedAICSS"
                    class="remove-style-icon"
                    src="../../assets/img/delete-icon-ai-styles.svg"
                    title="CSS löschen"
                    v-b-tooltip.hover.bottom
                    @click="removeAiStyles"
                  />
                </div>
                <textarea
                  disabled
                  @keydown.prevent
                  class="automatedaicss-textarea"
                  >{{ getAutomatedAICSS }}</textarea
                >
              </b-card>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { askChatGPT } from '@/services/workflow.service';
import LoadingSpinner from '@/components/widgets/LoadingSpinner.vue';
import { getApiEndpointVersion } from '@/utils/helpers';
export default {
  name: 'askAiUiModal',
  data() {
    return {
      uiPrompt: null,
      isShowAddCssBtn: false,
      isShowLoading: false,
      uiResponse: null,
      isShowCssTextArea: false,
      isVisibleAutomatedAICSSElement: false,
    };
  },
  emits: ['addUiInUiElement'],
  props: {
    elements: {
      type: Array,
      required: true,
    },
    flowRunnerEndpoint: {
      type: String,
    },
    isAiDropdownVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async onAskAiClick() {
      if (!this.uiPrompt || this.isShowLoading) return;

      try {
        this.isShowAddCssBtn = false;
        this.isShowCssTextArea = false;
        this.isShowLoading = true;

        const url = this.flowRunnerEndpoint;
        let prompt = `you are css code generator assistent with must follow given condition and not give any extra response.you will first read  provided question and must properly read provided array (data of array is representation of HTML form elements in json format in which type value means type of input and name value mean name value of input element) and understand json structure of element after that you without forgetting need to determine requested element type ,information about that element and their attributes value from given question and then you need to find element from given array in which if any element value like name value ,type value ,label value,option value available related to requested element then you will Respond with only the css code with #codelosForm prefix (because all element wrapper in form with id is codelosForm) for requested element according to question without explanation as css code not string else you will respond with message "Please Ask style Related Question For Available Element." not any extra word.
        array:${JSON.stringify(this.elements)}.
        question:"${this.uiPrompt}".`;
        let response;
        if (getApiEndpointVersion(url) >= 6) {
          const formData = new FormData();
          formData.append(
            'props',
            JSON.stringify({
              prompt,
              model: 'gpt-4',
            })
          );
          response = await askChatGPT(url, formData);
        } else {
          response = await askChatGPT(url, {
            prompt,
          });
        }
        this.uiResponse = response.data.message;
        this.isShowCssTextArea = true;
        if (!response.data.message.startsWith('Please')) {
          this.isShowAddCssBtn = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isShowLoading = false;
      }
    },
    onAddCssBtnClick() {
      this.$emit('addUiInUiElement', this.uiResponse, true);
      this.isShowAddCssBtn = false;
      this.isShowCssTextArea = false;
    },

    onToggleAICSSElement() {
      this.isVisibleAutomatedAICSSElement =
        !this.isVisibleAutomatedAICSSElement;
    },
    removeAiStyles() {
      this.$emit('removeAiCss');
    },
  },
  computed: {
    getAutomatedAICSS() {
      const automatedAICSSElement = this.elements.find(
        (element) => element.type === 'automatedaicss'
      );
      return automatedAICSSElement ? automatedAICSSElement.value : '';
    },
  },
  components: {
    LoadingSpinner,
  },
};
</script>
<style scoped>
.ask-ai-ui-modal {
  width: fit-content;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.loading-spinner {
  margin-top: 100px;
  padding-right: 61px;
}

.modal {
  text-align: left;
  border-left: 1px solid #dee3e9;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgb(222, 227, 233);
  border-radius: 0px 19px 19px 0px;
  background: #ffffff;
  display: block;
  text-align: left;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  height: 100%;
  position: relative;
  width: 425px;
}
.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
  font-size: 13px;
  margin: 0;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

label {
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  box-sizing: border-box;
  width: 100%;
}

.btn {
  text-decoration: none;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  cursor: unset;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  white-space: pre;
  font-size: 0.9375rem;
  opacity: 1;
  transition: transform 0.2s linear 0s, background-color 0.2s linear 0s;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  margin-bottom: 25px;
  margin-right: 15px;
}

.ask-ai-ui-modal .automatedaicss-toggle {
  width: 100%;
  height: 60px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,
    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  /* transition: all 400ms ease-in-out; */
}
.ask-ai-ui-modal .automatedaicss-toggle.active {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e9dfdf;
  border-bottom: none;
}

.ask-ai-ui-modal .automatedaicss-toggle-element.collapse .card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: 1px solid #e9dfdf;
}

.ask-ai-ui-modal .automatedaicss-toggle-icon {
  font-size: 36px;
  transition: transform 0.5s ease-in-out;
}
.ask-ai-ui-modal .automatedaicss-toggle-icon {
  width: 16px;
  transition: transform 0.5s ease-in-out;
}
.ask-ai-ui-modal .automatedaicss-toggle-icon.up {
  transform: rotate(180deg);
}
.ask-ai-ui-modal .prevent-pointer-event {
  pointer-events: none;
}

.ask-ai-ui-modal .automatedaicss-textarea {
  border: none;
}
.ask-ai-ui-modal .remove-style-icon {
  float: right;
  width: 20px;
  cursor: pointer;
}

.ask-ai-ui-modal .btn.btn-senden {
  white-space: normal;
}
</style>
